import * as React from "react"
import { parsePrice, createPrice } from "../../common/constants"
import { LabelContext } from "../../core/label.context"
import { GeneralContext } from "../../core/general.context"
import {
    PROJECT_LANGUAGE,
    calls, APPLY_ECO_PART_TO_PRICE, REFURBISHED
} from "../../core/APIUtils"
import { RESTContext } from "../../core/rest.context"
import {getBundlePrice, getAttributeFromProductProjection} from "../bundle/utils"


export const CartRecapProduct = (props: any) => {
    const { t } = React.useContext(LabelContext)
    const { cart, userData } = React.useContext(GeneralContext)
    const { ajax$ } = React.useContext(RESTContext)
    const [isBundle, setIsBundle] = React.useState(false)
    const [title, setTitle] = React.useState(props.title)
    const [refurbishedCode, setRefurbishedCode] = React.useState<string>("")
    const [sku, setSku] = React.useState(props.sku)
    const [bundlePrices, setBundlePrices] = React.useState<any>(null);
    const [productQuantity, setProductQuantity] = React.useState<number>(0)
    const [notDiscountedTotalPrice, setNotDiscountedTotalPrice] = React.useState<any>(null)
    const [totalPrice, setTotalPrice] = React.useState<any>(null)
    const [ecoPartPrice, setEcoPartPrice] = React.useState<number>(0)
    const [ecoPartLabel, setEcoPartLabel] = React.useState<string>('')


    // Logica bundle
    React.useEffect(() => {

        if (props.bundleKey) {
            ajax$(calls.Project.getProduct(props.bundleKey)).subscribe(
                bundleProjection => {
                    setIsBundle(true)
                    setTitle(bundleProjection.name[PROJECT_LANGUAGE])
                    let prices = getBundlePrice(bundleProjection, userData, true, cart)
                    prices.ecoPartecipationPrice = prices.ecoPartecipationPrice * props.item.quantity
                    setEcoPartLabel(t("ecommerce.common.product.ecoPartecipation").replace("[price]", prices?.ecoPartecipationPrice))
                    setBundlePrices(prices)

                    let productsInBundle = getAttributeFromProductProjection(bundleProjection, "bundle")
                    let skus = productsInBundle.reduce((skus: string, product: any) => {
                        return skus + product.obj.key + " (" + product.obj.masterData.current.name[PROJECT_LANGUAGE] + ")<br>"
                    }, "")
                    setSku(skus)

                    let _availableQuantity = 0
                    productsInBundle.forEach((product: any) => {
                        if (product.obj.masterData.current.masterVariant.availability.availableQuantity < _availableQuantity || _availableQuantity === 0) {
                            _availableQuantity = product.obj.masterData.current.masterVariant.availability.availableQuantity
                        }
                    })
                })
        }

    }, [props.bundleKey, props.item.quantity])


    React.useEffect(() => {
        /* I nomi delle variabil rispettano la struttura di CT */

        if(!isBundle){
            const ecoPartValue = props.item.variant.attributes.filter((attribute: any) => attribute.name === 'ecoPartecipationPrice')?.map((attribute: any) => attribute.value)
            if (ecoPartValue.length > 0) {
                setEcoPartLabel(t("ecommerce.common.product.ecoPartecipation").replace("[price]", (ecoPartValue[0] * props.item.quantity).toFixed(2)));
            }
            const ecoPartPrice = ecoPartValue && ecoPartValue.length > 0
                ? ecoPartValue[0]
                : NaN
            setEcoPartPrice(isNaN(ecoPartPrice) ? 0 : ecoPartPrice * props.item.quantity)
        }


        /*   Prezzo unitario per predotto   */
        let price__value = props.item.price.value

        /*   Prezzo unitario con promozione a prodotto.   Opzionale   */
        let price__discounted = props.item.price.discounted?.value

        /*   Prezzo unitario per promozione a carrello applicata a prezzo scontato.   Opzionale   */
        let discountedPrice = props.item.discountedPrice?.value

        /*   Prezzo totale (non unitario) riga con tutte promozioni applicate*/
        setTotalPrice(props.item.totalPrice)

        let _notDiscountedTotalPrice = undefined

        if (price__discounted || discountedPrice) {
            // Prezzo intero senza promozioni
            _notDiscountedTotalPrice = createPrice(price__value.centAmount * props.item.quantity, cart.totalPrice.currencyCode)
            setNotDiscountedTotalPrice(_notDiscountedTotalPrice)
        }

        setProductQuantity(Number(props.quantity))

        if (!props.bundleKey) {
            setSku(props.sku)
            setTitle(props.title)
        }
    }, [props.item, isBundle, cart])

    React.useEffect(() => {
        let refurbishChannelId = props?.item?.price?.channel?.id
        const refurbishedCode = REFURBISHED?.[refurbishChannelId]?.["code"]
        setRefurbishedCode(refurbishedCode)
    }, [props.item])
    
    return (
        <>
            {
                <div className="">
                    <div className="row">
                        <div className="col-7 font-size-14">
                            <div className="product-information">
                                {title}
                                <div dangerouslySetInnerHTML={{__html: sku}}></div>
                                {refurbishedCode && (
                                  <span>{t("product.refurbishedLevel")} {t(`product.refurbishedLevel-${refurbishedCode}`)}</span>
                                )}
                            </div>
                            <div className="product-quantity pb-3">{t("ecommerce.checkout.quantity-small")}: {props.quantity}</div>
                        </div>
                        <div className="col-5 text-right">
                            <>
                                {
                                    !isBundle
                                        ?
                                        <>
                                            {notDiscountedTotalPrice && totalPrice && notDiscountedTotalPrice?.centAmount !== totalPrice?.centAmount &&
                                                <div className="price price--strikethrough">{parsePrice(notDiscountedTotalPrice, undefined, undefined, ecoPartPrice)}</div>}
                                            {totalPrice &&
                                                <div className="price price--discounted">{parsePrice(totalPrice, undefined, undefined, ecoPartPrice)}</div>}
                                            {(APPLY_ECO_PART_TO_PRICE && ecoPartPrice > 0 && (<div className="ecoPartecipation-cart" dangerouslySetInnerHTML={{ __html: ecoPartLabel }}></div>))}
                                        </>
                                        :
                                        (bundlePrices &&
                                            <>
                                            {bundlePrices?.bundlePrice > 0
                                                ?
                                                <>
                                                    <div
                                                        className="price price--strikethrough">{parsePrice(createPrice(bundlePrices?.productsPrice * productQuantity, cart.totalPrice.currencyCode), undefined, undefined, bundlePrices?.ecoPartecipationPrice)}</div>
                                                    <div
                                                        className="price price--discounted"> {parsePrice(createPrice(bundlePrices?.bundlePrice * productQuantity, cart.totalPrice.currencyCode), undefined, undefined, bundlePrices?.ecoPartecipationPrice)}</div>
                                                </>
                                                :
                                                <>
                                                    <div className="price price--discounted"> {parsePrice(createPrice(bundlePrices?.productsPrice * productQuantity, cart.totalPrice.currencyCode), undefined, undefined, bundlePrices?.ecoPartecipationPrice)}</div>
                                                </>
                                            }
                                            {(APPLY_ECO_PART_TO_PRICE && bundlePrices?.ecoPartecipationPrice > 0 && (<div className="ecoPartecipation-cart" dangerouslySetInnerHTML={{ __html: ecoPartLabel }}></div>))}
                                            </>
                                        )
                                }
                                </>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}